import React from "react";
import { Navigate, useLocation, Route } from "react-router-dom";
import AdminFooter from "../Nature/Common/AdminFooter";
import AdminHeader from "../Nature/Common/AdminHeader";
import AdminSideBar from "../Nature/Common/AdminSideBar";

const ProtectedRoute = ({ children }) => {
  // const user = useSelector((state) => state.user);
  let location = useLocation();


  if (!sessionStorage.getItem("user")) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return (
    <>
      {window.location.href.includes("access") ? (
        children
      ) : (
        <>
         
          <AdminHeader />
          {window.location.href.includes("inspection") ? "" :  <AdminSideBar />}
         
          {children}
          <AdminFooter />
        </>
      )}
    </>
  );
};

export default ProtectedRoute;
